<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import { MarLoadingSpinner, MarModals } from '@nimling/components-nimtech'
import { get_me, meStore } from '@lib/store/me'
import { apiKey, get_mode, modeStore, signIn, signOut } from '@lib/store/session'
import { narrow, toggleSidebar, uiState } from '@lib/store/ui'
import Nav from '@components/Nav.vue'
import SignIn from '@components/SignIn.vue'

const collapsed = computed(() => uiState.value.sidebarCollapsed || narrow.value)
const shellStyle = computed(() => ({
  '--sidebar-size': collapsed.value ? '4rem' : '15rem',
  '--icon-cell': collapsed.value ? '3.5rem' : '3rem'
}))
const signedIn = computed(
  () => modeStore.value === 'platform' || (modeStore.value === 'standalone' && apiKey.value !== '' && meStore.value !== null)
)

const signInError = ref('')

async function load(submitted = '') {
  try {
    await get_me()
    signInError.value = ''
  } catch (e) {
    meStore.value = null
    if (modeStore.value === 'standalone' && (apiKey.value || submitted)) {
      signInError.value = (e as Error).message
      signOut()
    }
  }
}

onMounted(async () => {
  try {
    await get_mode()
  } catch {
    modeStore.value = 'platform'
  }
  await load()
})

watch([modeStore, apiKey], ([mode, key]) => {
  if (mode === 'standalone' && key === '') meStore.value = null
})

async function submit(value: string) {
  signIn(value)
  await load(value)
}
</script>

<template>
  <div v-if="modeStore === null" class="app-loading">
    <MarLoadingSpinner mode="inline" label="loading" />
  </div>
  <SignIn v-else-if="!signedIn" :error="signInError" @submit="submit" />
  <div v-else class="app-shell" :style="shellStyle">
    <Nav :collapsed="collapsed" @toggle-collapsed="toggleSidebar" />
    <div class="app-content">
      <RouterView v-slot="{ Component }">
        <Suspense :timeout="0">
          <component :is="Component" />
          <template #fallback>
            <div class="app-loading">
              <MarLoadingSpinner mode="inline" label="loading" />
            </div>
          </template>
        </Suspense>
      </RouterView>
    </div>
  </div>
  <MarModals />
</template>
